import {
    api_user_get,
    api_user_logout_post,
    StaffRole,
    User,
    UserSession,
} from 'abi'
import { Perms } from 'pages/shared'
import { createEffect, createRoot } from 'solid-js'
import { createStore } from 'solid-js/store'

export type SelfModel = {
    user: User | null
    fetch: boolean
    sessions: UserSession[]
    loading: boolean

    Aperms: Perms
    staff_role: StaffRole
}

const SELF_DEFAULT: SelfModel = {
    user: null,
    fetch: true,
    sessions: [],
    loading: true,
    Aperms: new Perms([]),
    staff_role: 'agent',
}

async function fetch_self() {
    setSelf({ loading: true })

    try {
        let res = await api_user_get({ show_alert: false })

        if (res.err()) {
            return setSelf({ ...SELF_DEFAULT })
        }
        let user_info = res.body

        setSelf({
            fetch: false,
            user: user_info,
            sessions: [],

            Aperms: new Perms(user_info.admin_perms || []),
            // Sperms: new StaffPerms(user_info.staff_perms || []),
            staff_role: user_info.staff_role,
        })
    } catch {
        setSelf({ ...SELF_DEFAULT })
    }
}

export const userRole = (user: User): string => {
    if (new Perms(user.admin_perms || []).check(Perms.MASTER)) return 'ادمین کل'

    if (new Perms(user.admin_perms || []).any()) return 'ادمین'

    if (user.staff_role == 'manager') return 'مدیر عامل'

    if (user.staff_role == 'agent') return 'نماینده'

    return 'بدون دسترسی'
}

export async function logoutUser() {
    let res = await api_user_logout_post({ show_alert: true })

    if (!res.ok()) return

    location.reload()
}

const [self, setSelf] = createStore<SelfModel>({ ...SELF_DEFAULT })

createRoot(() => {
    createEffect(() => {
        if (self.fetch) {
            fetch_self().finally(() => setSelf({ loading: false }))
            return
        }
    })
})

export { self, setSelf }
